var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96838 1.37573H7.03088C6.94755 1.37573 6.90588 1.4174 6.90588 1.50073V6.40698H2.25C2.16667 6.40698 2.125 6.44865 2.125 6.53198V7.46948C2.125 7.55282 2.16667 7.59448 2.25 7.59448H6.90588V12.5007C6.90588 12.5841 6.94755 12.6257 7.03088 12.6257H7.96838C8.05172 12.6257 8.09338 12.5841 8.09338 12.5007V7.59448H12.75C12.8333 7.59448 12.875 7.55282 12.875 7.46948V6.53198C12.875 6.44865 12.8333 6.40698 12.75 6.40698H8.09338V1.50073C8.09338 1.4174 8.05172 1.37573 7.96838 1.37573Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.80ee23c91ade7a91877965d8bf23b1cd.svg";
export { ForwardRef as ReactComponent };